<template>
  <v-container class="pa-0">
    <v-row dense row wrap justify="center">
      <v-col class="col-12 text-center">
        <v-btn-toggle
          mandatory
          v-model="selectedTab"
          @change="handleChangeSelectedTab"
          dense
        >
          <v-btn x-small value="all" :disabled="hasEssentials">All</v-btn>
          <v-btn x-small value="verified">Verified</v-btn>
          <v-btn x-small value="detected" :disabled="hasEssentials"
            >Events AI</v-btn
          >
          <v-btn x-small value="hotspots">Hotspots</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row dense row wrap justify="center">
      <v-col class="col-12">
        <SearchFilterEventsDetected
          v-if="eventType && eventType !== 'verified'"
          :type="eventType"
          :hotspotsOnlySelected="hotspotsOnlySelected"
          :selected-topics="selectedTopics"
          :reset="reset"
          :map-type="mapType"
          :selected-severity="selectedSeverity"
          :selected-sentiment="selectedSentiment"
          :selected-emotions="selectedEmotions"
          @change="handleChangeDetected"
          @change-map-type="handleChangedMapType"
          @change-severity="handleChangeSeverity"
          @change-sentiment="handleChangeSentiment"
          @change-emotions="handleChangeEmotions"
          :for-live-search="true"
          :topic-filter-counts="topicFilterCounts"
          :source-filter-counts="sourceFilterCounts"
          :sentiment-filter-counts="sentimentFilterCounts"
          :emotions-filter-counts="emotionsFilterCounts"
          :selected-sources="selectedSources"
          @changed-live-search="handleChangeEvents"
          @change-has-topics-selected="handleChangeHasTopicsSelected"
          :selected-geolocation-precisions="selectedGeolocationPrecisions"
          @change-geolocation-precisions="handleChangeGeolocationPrecisions"
          :geolocation-precision-filter-counts="
            geolocationPrecisionFilterCounts
          "
        ></SearchFilterEventsDetected>

        <SearchFilterEventsVerified
          v-if="eventType === 'verified'"
          :selected-topics="selectedTopics"
          :primary-topics="incidentTopics"
          :reset="reset"
          :map-type="mapType"
          @change="handleChangeVerified"
          @change-map-type="handleChangedMapType"
          :for-live-search="true"
          :topic-filter-counts="topicFilterCounts"
          :sources-type-selection="sourcesSelection"
          :verified-type-selection="verifiedTypeSelection"
          :verified-extras-selection="verifiedExtrasSelection"
          @changed-live-search="handleChangeEvents"
          @change-has-topics-selected="handleChangeHasTopicsSelected"
          @change-geolocation-precisions="handleChangeGeolocationPrecisions"
          @change-severity="handleChangeSeverity"
          :selected-geolocation-precisions="selectedGeolocationPrecisions"
          :selected-severity="selectedSeverity"
          :geolocation-precision-filter-counts="
            geolocationPrecisionFilterCounts
          "
        ></SearchFilterEventsVerified>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashHas from "lodash/has";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_USER } from "@/store";

import {
  getPrimaryTopics,
  getAllPrimaryTopics,
} from "@/services/events/topics.service";
import { hasEssentialsAccess } from "@/services/user/user.service";

const EMITTED_ACTIONS = {
  //TODO better name? its not really events any more..
  CHANGE_EVENTS: "change-events",
  CHANGE_HOTSPOTS_FILTER: "change-hotspots-filter",
  CHANGE_SOURCES: "change-sources",
  CHANGE_TAB: "change-tab",
  CHANGE_SEVERITY: "change-severity",
  CHANGE_SENTIMENT: "change-sentiment",
  CHANGE_EMOTIONS: "change-emotions",
  CHANGE_GEOLOCATION_PRECISIONS: "change-geolocation-precisions",
};

const EVENT_PICKER_ACTIONS = {
  CHANGED_LIVE_SEARCH: "changed-live-search",
  CHANGE_HAS_TOPICS_SELECTED: "change-has-topics-selected",
};

export default {
  name: "SearchFilterEvents",
  components: {
    SearchFilterEventsDetected: () =>
      import("@/components/search/SearchFilterEventsDetected"),
    SearchFilterEventsVerified: () =>
      import("@/components/search/SearchFilterEventsVerified"),
  },
  props: {
    reset: {
      type: String,
    },
    selectedTopics: {
      type: String,
    },
    //TODO fix this
    // eventsSelection: {
    //   type: Object,
    //   default() {},
    // },
    sourcesSelection: {
      type: String,
    },
    verifiedTypeSelection: {
      type: String,
    },
    verifiedExtrasSelection: {
      type: Object,
    },
    mapType: {
      type: String,
      default: "marker",
    },
    eventsTypeSelection: {
      type: String,
    },
    hotspotsOnlySelection: {
      type: Boolean,
    },
    topicFilterCounts: {
      type: Object,
    },
    sourceFilterCounts: {
      type: Object,
    },
    sentimentFilterCounts: {
      type: Object,
    },
    emotionsFilterCounts: {
      type: Object,
    },
    selectedSentiment: {
      type: Array,
    },
    selectedEmotions: {
      type: Array,
    },
    selectedSources: {
      type: Object,
    },
    selectedGeolocationPrecisions: {
      type: Array,
    },
    geolocationPrecisionFilterCounts: {
      type: Object,
    },
    selectedSeverity: {
      type: Object,
    },
  },
  data() {
    const hasEssentials = hasEssentialsAccess();
    return {
      eventType: hasEssentials ? "verified" : "all",
      selectedTab: hasEssentials ? "verified" : "all",
      topics: lodashCloneDeep(getAllPrimaryTopics()),
      incidentTopics: [
        {
          apiName: "security",
          plural: "Security",
          subtopics: this.transformSubtopics("security"),
        },
        {
          apiName: "maritime",
          plural: "Maritime",
          subtopics: this.transformSubtopics("maritime"),
        },
      ],
      selectedSectors: null,
      sectors: null,
      selectedVeAssets: null,
      veAssets: null,
      attackTypes: null,
      selectedAttackTypes: null,
      perpetrators: null,
      selectedPerpetrators: null,
      maritimeSubcategories: null,
      selectedMaritimeSubcategories: null,
      maritimeVesselTypes: null,
      selectedMaritimeVesselTypes: null,
      //todo what about this....
      verifiedType: null,
      hotspotsOnlySelected: false,
      hasEssentials: hasEssentials,
    };
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
  },
  async mounted() {
    // Set the selected tab based on saved preferences
    switch (this.preferences.liveSearch?.eventType) {
      case "hotspots":
        this.selectedTab = "hotspots";
        break;
      case "verified":
        this.selectedTab = "verified";
        break;
      case "detected":
        this.selectedTab = this.eventsTypeSelection;
        break;
    }
    this.selectedTab = hasEssentialsAccess() ? "verified" : this.selectedTab;
    this.handleChangeSelectedTab();
  },
  methods: {
    //TODO the difference between this and verified seems unecessary and confusing
    handleChangeDetected(params) {
      if (lodashHas(params, "selectedTopics")) {
        this.selectedSectors = null;
        this.selectedVeAssets = null;
        this.selectedAttackTypes = null;
        this.selectedPerpetrators = null;
        this.selectedMaritimeSubcategories = null;
        this.selectedMaritimeVesselTypes = null;
        this.$emit(EMITTED_ACTIONS.CHANGE_EVENTS, {
          eventType: this.eventType,
          events: params.selectedTopics,
          sectors: this.selectedSectors,
          veAssets: this.selectedVeAssets,
          severity: this.selectedSeverity,
          attackTypes: this.selectedAttackTypes,
          perpetrators: this.selectedPerpetrators,
          maritimeSubcategories: this.selectedMaritimeSubcategories,
          maritimeVesselTypes: this.selectedMaritimeVesselTypes,
          verifiedMapType: this.verifiedMapType,
          mapType: this.mapType,
        });
      } else if (params.hasOwnProperty("hotspotsOnly")) {
        this.$emit(EMITTED_ACTIONS.CHANGE_HOTSPOTS_FILTER, {
          hotspotsOnly: params.hotspotsOnly,
        });
      } else if (lodashGet(params, "sources")) {
        this.$emit(EMITTED_ACTIONS.CHANGE_SOURCES, params.sources);
      }
    },
    handleChangeVerified(params) {
      if (params.verifiedType) {
        this.verifiedType = params.verifiedType;
      }
      if (params.sectors) {
        this.sectors = params.sectors;
      }
      if (params.veAssets) {
        this.veAssets = params.veAssets;
      }
      if (params.attackTypes) {
        this.attackTypes = params.attackTypes;
      }
      if (params.perpetrators) {
        this.perpetrators = params.perpetrators;
      }
      if (params.maritimeSubcategories) {
        this.maritimeSubcategories = params.maritimeSubcategories;
      }
      if (params.maritimeVesselTypes) {
        this.maritimeVesselTypes = params.maritimeVesselTypes;
      }
      if (!isNaN(params.severityMin) || !isNaN(params.severityMax)) {
        this.severity = {
          severityMin: params.severityMin || 0,
          severityMax: params.severityMax || 10,
        };
      }

      let selectedTopicsToUse = this.selectedTopics;
      if (lodashHas(params, "selectedTopics")) {
        selectedTopicsToUse = params.selectedTopics;
      }

      if (params.geolocationPrecisions) {
        this.geolocationPrecisions = params.geolocationPrecisions;
      }

      this.$emit(EMITTED_ACTIONS.CHANGE_EVENTS, {
        eventType: this.eventType,
        verifiedType: this.verifiedType,
        events: selectedTopicsToUse,
        sectors: this.sectors,
        veAssets: this.veAssets,
        perpetrators: this.perpetrators,
        attackTypes: this.attackTypes,
        maritimeSubcategories: this.maritimeSubcategories,
        maritimeVesselTypes: this.maritimeVesselTypes,
        mapType: this.mapType,
        geolocationPrecisions: this.geolocationPrecisions,
      });
    },
    handleChangedMapType(val) {
      this.$emit(EMITTED_ACTIONS.CHANGE_EVENTS, {
        eventType: this.eventType,
        verifiedType: this.verifiedType,
        events: this.selectedTopics,
        sectors: this.sectors,
        veAssets: this.veAssets,
        perpetrators: this.perpetrators,
        attackTypes: this.attackTypes,
        maritimeSubcategories: this.maritimeSubcategories,
        maritimeVesselTypes: this.maritimeVesselTypes,
        severity: this.severity,
        mapType: val,
      });
    },
    handleChangeSelectedTab() {
      this.selectedSectors = null;
      this.selectedVeAssets = null;
      this.selectedAttackTypes = null;
      this.selectedPerpetrators = null;
      this.maritimeSubcategories = null;
      this.maritimeVesselTypes = null;
      this.verifiedType = null;

      this.eventType =
        this.selectedTab === "hotspots" ? "detected" : this.selectedTab;

      this.hotspotsOnlySelected = this.selectedTab === "hotspots";

      this.$emit(EMITTED_ACTIONS.CHANGE_TAB, { eventType: this.eventType });

      this.$emit(EMITTED_ACTIONS.CHANGE_HOTSPOTS_FILTER, {
        hotspotsOnly: this.selectedTab === "hotspots",
      });

      this.$emit(EMITTED_ACTIONS.CHANGE_EVENTS, {
        eventType: this.eventType,
        verifiedType: null,
        events: this.selectedTopics,
        sectors: null,
        veAssets: null,
        attackTypes: null,
        perpetrators: null,
        maritimeSubcategories: null,
        maritimeVesselTypes: null,
        severity: null,
        mapType: this.mapType,
      });
    },
    transformSubtopics(type) {
      let subtopics = lodashCloneDeep(getPrimaryTopics(type));

      for (let subtopic of subtopics) {
        if (!lodashHas(subtopic, "parentIds") || !subtopic.parentIds) {
          subtopic.parentIds = [];
        }
        subtopic.parentIds.push(type);
      }
      return subtopics;
    },
    handleChangeEvents(item, itemsCopy, eventType) {
      this.$emit(
        EVENT_PICKER_ACTIONS.CHANGED_LIVE_SEARCH,
        item,
        itemsCopy,
        eventType
      );
    },
    handleChangeHasTopicsSelected(val) {
      this.$emit(EVENT_PICKER_ACTIONS.CHANGE_HAS_TOPICS_SELECTED, val);
    },
    setTabByProps() {
      if (this.hotspotsOnlySelection) {
        this.selectedTab = "hotspots";
      } else if (
        this.eventsTypeSelection === "verified" &&
        (this.verifiedTypeSelection || this.hasEssentials)
      ) {
        this.selectedTab = "verified";
      } else {
        this.selectedTab = this.eventsTypeSelection;
        //TODO are topics remembered?
      }
      this.handleChangeSelectedTab();
    },
    handleChangeSeverity(val) {
      this.$emit(EMITTED_ACTIONS.CHANGE_SEVERITY, val);
    },
    handleChangeSentiment(val) {
      this.$emit(EMITTED_ACTIONS.CHANGE_SENTIMENT, val);
    },
    handleChangeEmotions(val) {
      this.$emit(EMITTED_ACTIONS.CHANGE_EMOTIONS, val);
    },
    handleChangeGeolocationPrecisions(val) {
      this.$emit(EMITTED_ACTIONS.CHANGE_GEOLOCATION_PRECISIONS, val);
    },
  },
  watch: {
    eventsTypeSelection: {
      handler() {
        this.setTabByProps();
      },
    },
    hotspotsOnlySelection: {
      handler() {
        this.setTabByProps();
      },
    },
    verifiedTypeSelection: {
      handler() {
        this.setTabByProps();
      },
    },
    reset: {
      handler() {
        this.sectors = null;
        this.veAssets = null;
        this.perpetrators = null;
        this.attackTypes = null;
        this.maritimeSubcategories = null;
        this.maritimeVesselTypes = null;
        this.severity = null;
        this.selectedTab = this.hasEssentials ? "verified" : "all";
        this.handleChangeSelectedTab();
      },
    },
  },
  beforeDestroy() {
    this.topics = null;
  },
};
</script>

<style></style>
